import pluralize from "pluralize";
import React from "react";

import type { OfferQuantityButtonType } from "@intelligems/ig-types";
import { styled } from "@mui/material";

import { cls } from "../../util";
import { useQuantityButtonsContext } from "../context/QuantityButtonsContext";

interface PriceSectionProps {
  button: OfferQuantityButtonType;
  discountedUnitPrice: string;
  className?: string;
}

export const PriceSection = ({
  button,
  discountedUnitPrice,
  className,
}: PriceSectionProps) => {
  const { widget } = useQuantityButtonsContext();

  return (
    <Section className={cls("ig-volume-widget-price-section", className)}>
      <Inner>
        <Text className={"ig-volume-widget-price-section-text"}>
          {isNaN(button.quantity) ? "1" : button.quantity}{" "}
          {button.unitName || pluralize("units", button.quantity || 0)}
        </Text>
        <div className={"ig-volume-widget-price-section-text"}>
          <Price className={"ig-volume-widget-price-section-price"}>
            {discountedUnitPrice}{" "}
            <span className={"ig-volume-widget-price-section-each"}>
              {widget.variables?.textReplacements?.each}
            </span>
          </Price>
        </div>
      </Inner>
    </Section>
  );
};

const Section = styled("div")({
  margin: "-13px 0px 0px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  placeContent: "space-around",
  placeItems: "center",
  boxAlign: "center",
  height: "100%",
});

const Inner = styled("div")({
  textAlign: "center",
});

const Text = styled("div")({
  marginBottom: 3,
});

const Price = styled("span")({
  fontWeight: 600,
});
